import { FC } from 'react';

import { Box, InputAdornment, useTheme } from '@mui/material';

import { colors } from '@/theme/variables';

interface UnitAdornmentProps {
  label: string;
  roundedRight?: boolean;
}

export const UnitAdornment: FC<UnitAdornmentProps> = ({
  label,
  roundedRight = true,
}) => {
  const theme = useTheme();

  return (
    <InputAdornment
      position="end"
      sx={{
        alignSelf: 'stretch',
        height: 'auto',
        maxHeight: 'none',
        margin: '-4px -10px -4px 10px',
      }}
    >
      <Box
        alignItems="center"
        bgcolor={
          theme.palette.mode === 'dark'
            ? theme.palette.background.formSubHeader
            : colors.grey[10]
        }
        borderLeft={`1px solid ${
          theme.palette.mode === 'dark' ? colors.grey[60] : colors.grey[20]
        }`}
        borderRadius={roundedRight ? '0 5px 5px 0' : 0}
        color={
          theme.palette.mode === 'dark'
            ? theme.palette.text.primary
            : colors.grey[80]
        }
        display="flex"
        height="100%"
        justifyContent="center"
        minWidth={40}
        px={1}
      >
        {label}
      </Box>
    </InputAdornment>
  );
};

export default UnitAdornment;
